import api from './api';

const API_URL = '/api/auth';

const register = (data) => {
  return api.post(`${API_URL}/register`, data);
};

const login = (data) => {
  return api.post(`${API_URL}/login`, data);
};

// Nueva función para consumir el endpoint de verificación OTP en el backend
const verifyEmail = (email, token) => {
  return api.post(`${API_URL}/verify-email`, { email, token });
};

const forgotPassword = (email) => {
  return api.post(`${API_URL}/forgot-password`, { email });
};

const resetPassword = (token, newPassword) => {
  return api.post(`${API_URL}/reset-password`, { token, newPassword });
};

const authService = {
  register,
  login,
  verifyEmail,
  forgotPassword,
  resetPassword
};

export default authService;